import { render, staticRenderFns } from "./orderAudio.vue?vue&type=template&id=62924494"
import script from "./orderAudio.vue?vue&type=script&lang=js"
export * from "./orderAudio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports